/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTInputNumber } from './input-number';
export type {
	KTInputNumberConfigInterface,
	KTInputNumberEventPayloadInterface,
	KTInputNumberInterface,
} from './types';
